$(document).ready(() => {
    $('#application-form-page-form').submit((e) => $('#application-form-page-button').prop('disabled', true));
});